import { h } from 'preact'
import { Text } from 'preact-i18n'

export default () =>
    <div class="limba__heading">
        <h1><Text id="headline.text" /></h1>
        <h2><Text id="headline.subline" /></h2>
    </div>


// WEBPACK FOOTER //
// ./js/components/Headline.js